// components/ContractCard.js
import React from 'react';
import { Typography, IconButton, Grid2, Paper, Button } from '@mui/material';
import { formatDate } from './formatDate';
import PaymentFacts from './PaymentFacts';

const ContractCard = ({ contract, onClick, showPaymentFacts = false }) => {
  return (
    <Paper
      key={contract.id}
      sx={{
        p: 2,
        mb: 2,
        cursor: 'pointer',
        position: 'relative',
      }}
      onClick={onClick}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={6}>
          <Typography variant="caption">เลขที่สัญญา</Typography>
          <Typography variant="h6" color="primary">
            {contract.contractNumber}
          </Typography>
        </Grid2>

        <Grid2 size={6}>
          <Typography variant="caption">ค่างวด/ชำระขั้นต่ำ</Typography>
          <div flexitem="true">
            <Typography
              variant="h6"
              color="secondary"
              sx={{ display: 'inline-block' }}
            >
              {contract.minimumPayment.toLocaleString()}
            </Typography>
            <Typography variant="caption" sx={{ marginLeft: 1 }}>
              บาท
            </Typography>
          </div>
        </Grid2>

        <Grid2 size={6}>
          <Typography variant="caption">วันที่ทำสัญญา</Typography>
          <Typography variant="body2" color="secondary">
            {formatDate(contract.createdDate)}
          </Typography>
        </Grid2>

        <Grid2 size={6}>
          <Typography variant="caption">ยอดกู้</Typography>
          {contract.type !== 99 ? (
            <>
              <div flexitem="true">
                <Typography
                  variant="body1"
                  color="primary"
                  sx={{ display: 'inline-block' }}
                >
                  {contract.credit.toLocaleString()}
                </Typography>
                <Typography variant="caption" sx={{ marginLeft: 1 }}>
                  บาท
                </Typography>
              </div>
            </>
          ) : (
            <Typography variant=" controlarbody1" color="primary">
              ติดต่อบริษัท
            </Typography>
          )}
        </Grid2>

        {showPaymentFacts && (
          <PaymentFacts contract={contract} columns />
        )}
      </Grid2>

      <Button
        variant="contained"
        size="small"
        sx={{
          position: 'absolute',
          right: 16,
          top: '50%',
          transform: 'translateY(-50%)',
          minWidth: 'auto', // Makes button smaller by removing minimum width
          padding: '4px 12px', // Adjust padding for smaller size
          borderRadius: '16px', // Rounded corners
          backgroundColor: '#1976d2', // Blue background (MUI primary blue)
          color: '#fff', // White text
          '&:hover': {
            backgroundColor: '#115293', // Darker blue on hover
          },
        }}
        onClick={onClick}
      >
        ดูข้อมูล
      </Button>
    </Paper>
  );
};

export default ContractCard;
